import { Image } from '~/lib/ApiModel';
import { IApiClient } from '~/lib/ApiClient';
import { loadAllItems } from '~/lib/helper/PagingHelper';
import { AsyncStore } from './AsyncStore';
import { computed, makeObservable } from 'mobx';

export class OperatingSystemStore extends AsyncStore<Image[]> {
    constructor(apiClient: IApiClient) {
        super(() => loadAllItems((link) => apiClient.getOperatingSystems(link)), []);
        makeObservable(this);
    }

    @computed
    get items() {
        return this.item;
    }
}
